import type { DrawerHistoryItem } from './DrawerContent/DrawerContent';

export const DRAWER_PARAM = 'left';

const STACK_SEP = '~';

function parseDrawerItem(token: string): DrawerHistoryItem | null {
  const sep = token.indexOf(':');
  if (sep === -1) {
    return null;
  }
  const type = token.slice(0, sep);
  const rest = token.slice(sep + 1);
  switch (type) {
    case 'file': {
      const [fileId, pageStr] = rest.split(':');
      if (!fileId) {
        return null;
      }
      const page = pageStr ? parseInt(pageStr, 10) : undefined;
      return { type: 'file', id: fileId, page };
    }
    case 'task':
      return rest ? { type: 'task', id: rest } : null;
    case 'claim':
      return rest ? { type: 'claim', id: rest } : null;
    case 'artifact':
      return rest ? { type: 'artifact', id: rest } : null;
    case 'wiki':
      return rest ? { type: 'wiki', path: decodeURIComponent(rest) } : null;
    default:
      return null;
  }
}

export function encodeDrawerItem(item: DrawerHistoryItem): string {
  switch (item.type) {
    case 'file':
      return item.page != null
        ? `file:${item.id}:${item.page}`
        : `file:${item.id}`;
    case 'task':
      return `task:${item.id}`;
    case 'claim':
      return `claim:${item.id}`;
    case 'artifact':
      return `artifact:${item.id}`;
    case 'wiki':
      return `wiki:${encodeURIComponent(item.path)}`;
    default:
      return '';
  }
}

export function parseDrawerStack(
  searchParams: URLSearchParams
): DrawerHistoryItem[] {
  const raw = searchParams.get(DRAWER_PARAM);
  if (!raw) {
    return [];
  }
  return raw
    .split(STACK_SEP)
    .map(parseDrawerItem)
    .filter((item): item is DrawerHistoryItem => item !== null);
}

export function encodeDrawerStack(items: DrawerHistoryItem[]): string {
  return items.map(encodeDrawerItem).join(STACK_SEP);
}
